import { lazy } from 'react';

export const Home = lazy(() => import('@pages/Home'));
export const AccountingCenter = lazy(() => import('@pages/AccountingCenter'));
export const HedgingCenter = lazy(() => import('@pages/HedgingCenter'));
export const Pricers = lazy(() => import('@pages/Pricers'));
export const DebtPricer = lazy(() => import('@pages/DebtPricer'));
export const ResetPassword = lazy(() => import('@pages/ResetPassword'));
export const NotFound = lazy(() => import('@pages/NotFound'));
export const NoAccess = lazy(() => import('@pages/NoAccess'));
export const Profile = lazy(() => import('@pages/Profile'));
export const Settlements = lazy(() => import('@pages/Settlements'));
export const SponsorDashboard = lazy(() => import('@pages/SponsorDashboard'));
export const UsersPage = lazy(() => import('@/pages/users'));
export const TermsAgreement = lazy(() => import('@pages/TermsAgreement'));
export const TermsPage = lazy(() => import('@pages/Terms'));
export const CreateNewUser = lazy(
  () => import('@pages/Profile/components/CreateUser'),
);
export const MarketCurvesCalculation = lazy(
  () => import('@pages/MarketCurvesCalculation'),
);
export const IrMarketData = lazy(
  () => import('@pages/MarketCurvesCalculation/components/IrMarketDataCard'),
);
export const MarketDataCurves = lazy(
  () =>
    import('@pages/MarketCurvesCalculation/components/MarketDataCurvesCard'),
);
export const MarketDataAnalyzer = lazy(
  () =>
    import('@pages/MarketCurvesCalculation/components/MarketDataAnalyzerPage'),
);
export const FxMarketData = lazy(
  () => import('@pages/MarketCurvesCalculation/components/FxMarketDataCard'),
);
export const CommodityMarketData = lazy(
  () => import('@pages/MarketCurvesCalculation/components/CommodityCard'),
);
export const MarketReports = lazy(
  () => import('@pages/MarketCurvesCalculation/components/MarketReportsCard'),
);
export const TradeCenter = lazy(() => import('@/pages/TradeCenter'));
export const ReportCenter = lazy(() => import('@pages/ReportCenter'));
export const CompanyCenter = lazy(() => import('@pages/CompanyCenter'));
export const DebtCentre = lazy(() => import('@pages/DebtCentre'));
export const TransactionDetail = lazy(() => import('@pages/TransactionDetail'));
export const FundLevelAdmin = lazy(() => import('@/pages/FundLevelAdmin'));
export const FundSettlement = lazy(() => import('@/pages/FundSettlement'));
export const ComplianceCentre = lazy(() => import('@/pages/ComplianceCentre'));
export const TransactionRolling = lazy(
  () => import('@/pages/TransactionRolling'),
);
export const Banks = lazy(() => import('@/pages/Banks'));
export const ScheduledDeliverables = lazy(
  () => import('@pages/ScheduledDeliverables'),
);
export const RunDeliverables = lazy(() => import('@pages/RunDeliverable'));
export const JournalEntries = lazy(() => import('@pages/JournalEntries'));
export const HedgeAccounting = lazy(
  () => import('@pages/HedgeAccountingAdmin'),
);
export const HedgeAccountingV2 = lazy(
  () => import('@pages/HedgeAccountingAdminV2'),
);
export const HedgeAccountingTradeItem = lazy(
  () => import('@pages/HedgeAccountingAdminV2/components/TradeItem'),
);
export const FundLevelCenter = lazy(() => import('@pages/FundLevelCenter'));
export const TradeNotification = lazy(() => import('@pages/TradeNotification'));
export const EntityPortfolio = lazy(() => import('@pages/EntityPortfolio'));
export const Deals = lazy(() => import('@pages/Deals'));
export const Deal = lazy(() => import('@pages/Deal'));
export const RiskManagementAnalysis = lazy(
  () => import('@pages/RiskManagementAnalysis'),
);
export const IrAnalysis = lazy(() => import('@pages/IRanalysis'));
export const FxAnalysis = lazy(() => import('@pages/FxAnalysis'));
export const Rebalancing = lazy(() => import('@pages/Rebalancing'));
export const DealContingentMarketData = lazy(
  () => import('@pages/DealContingentAnalysis'),
);
export const TransactionCostAnalysis = lazy(
  () => import('@pages/TransactionCostAnalysis'),
);
export const FLCashConsumption = lazy(() => import('@pages/FLCashConsumption'));
export const HAAdmin = lazy(() => import('@pages/HAAdmin'));
export const DealsManagement = lazy(() => import('@pages/DealsManagement'));
export const Tutorials = lazy(() => import('@pages/Tutorials'));
export const ApiDocs = lazy(() => import('@pages/ApiDocs'));
export const UserRole = lazy(() => import('@pages/UserRole'));
export const DebtJournalEntries = lazy(
  () => import('@pages/DebtJournalEntries'),
);
export const ValidationDashboard = lazy(() => import('@pages/ValidationDashboard'));
export const GVOpportunities = lazy(() => import('@pages/GVOpportunities'));
